export default "__VITE_ASSET__a3a88088__"